import DocumentTab from './DocumentTab.vue';

export default DocumentTab;
